// ISQ (initial suggested questions) slice — fields are published directly by
// useMessageHistory (WS-10.1); see .claude/context/message-history.md and store-slices.md.
export const suggestionsSlice = (set) => ({
  isSuggestedQuestionsLoading: false,
  wereQuestionsGenerated: false,
  setIsSuggestedQuestionsLoading: (value) => set({ isSuggestedQuestionsLoading: value }),
  setWereQuestionsGenerated: (value) => set({ wereQuestionsGenerated: value }),
});
